import { render, staticRenderFns } from "./StaffScreen.vue?vue&type=template&id=d9b9484c&"
import script from "./StaffScreen.vue?vue&type=script&lang=ts&"
export * from "./StaffScreen.vue?vue&type=script&lang=ts&"
import style0 from "./StaffScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports